<template>
    <div class="decrees-bar">
        <div class="decrees-label" v-if="renderLabel">
            Decrees:
        </div>
        <div class="decrees-bar-content">
            <decree-widget
                :decree="decree"
                :index="index" v-for="(decree, index) in decrees"
                :key="`decree-${decree.id}`"
                :drafting="drafting"
                :hideMarkers="hideMarkers"
            />
            <span class="decrees-bar-info-wrapper" @click="showDecreesModal">
                <fa-icon class="decrees-bar-info-icon" icon="info-circle" />
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['renderLabel', 'drafting', 'hideMarkers', 'decrees'],
    name: 'decrees-bar',
    methods: {
        showDecreesModal() {
            this.$store.dispatch('setShowDecreesModal', true);
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .decrees-bar {
        display: flex;
        justify-content: center;
        position: relative;

        .decrees-label {
            align-self: center;
            font-weight: bold;
            font-family: 'RobotoSlab', 'Avenir', Helvetica, Arial, sans-serif;
            margin-bottom: 15px;
        }

        .decrees-bar-content {
            display: flex;
            justify-content: center;
            padding: 0 15px;
            position: relative;

            .decree-ribbon {
                padding: 5px 10px;

                .decree-coin {
                    height: 45px;
                    width: 45px;
                    margin-right: 5px;
                    display: inline-block;
                    vertical-align: middle;

                    &:last-of-type {
                        margin-right: 0;
                    }
                }
            }
        }

        .decrees-bar-info-wrapper {
            position: absolute;
            right: -25px;
            top: 50%;
            transform: translateY(-50%);

            .decrees-bar-info-icon {
                background: white;
                border-radius: 50%;
                color: $sage-brown;
                font-size: 1.4em;
                vertical-align: middle;
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .decrees-bar {

            .decrees-label {
                margin-bottom: 0;
            }

            .decrees-bar-content {

                .decree-widget {
                    display: flex;

                    > * {
                        align-self: center;
                    }
                }
            }
        }
    }

</style>
